import getLanguage from "./getLanguage"
import TRANSLATIONS from 'constants/translations'

export default function getLocalized(id, lowecase) {
    const currLanguageTranslation = TRANSLATIONS[getLanguage()]
    const genericTranslation = TRANSLATIONS.generic

    let val = id

    if (genericTranslation[id]) {
        val = genericTranslation[id]
    } else if (currLanguageTranslation[id]) {
        val = currLanguageTranslation[id]
    }

    if (lowecase) return val.toLowerCase()
    return val
}